import { presenceFrom } from "@/lib/presence";

const DOT = { online: "#16a34a", recent: "#f59e0b", away: "#94a3b8", idle: "#cbd5e1" };

// Compact "recently active / online" indicator driven by last_active_at.
export function PresenceBadge({ lastActiveAt, className = "" }) {
  const p = presenceFrom(lastActiveAt);
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-xs ${className}`}
      data-testid="presence-badge"
      title={lastActiveAt ? `Last active: ${new Date(lastActiveAt).toLocaleString()}` : "No activity recorded"}
    >
      <span
        className="h-2 w-2 shrink-0 rounded-full"
        style={{ backgroundColor: DOT[p.tone], boxShadow: p.online ? "0 0 0 3px rgba(22,163,74,0.18)" : "none" }}
      />
      <span className={p.online ? "font-semibold text-emerald-700" : "text-slate-500"}>{p.label}</span>
    </span>
  );
}
